import { render, staticRenderFns } from "./RevenueTypeDelete.vue?vue&type=template&id=4aef2ec6&scoped=true&"
import script from "./RevenueTypeDelete.vue?vue&type=script&lang=js&"
export * from "./RevenueTypeDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aef2ec6",
  null
  
)

export default component.exports